import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { api } from '../../../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import InfiniteScroll from 'react-infinite-scroll-component'
import Loader from '../../../components/Loader'
import AdProductCard from '../../../components/AdProductCard'

const ProductsAds = () => {
    const [products, setProducts] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [page, setPage] = useState(1)

    const navigate = useNavigate()

    const { name } = useParams()

    useEffect(() => {
        const getProducts = async () => {
            try {
                setIsLoading(true)
                const response = await api.get(`/stores/${name}/products`, { params: { page } })
                console.log(response)
                if (response) {
                    setIsLoading(false)
                    setProducts(response.data)
                }
            } catch (error) {
                setIsLoading(false)
                toast.error(error.response.data.message)
            }
        }

        getProducts()
    }, [])

    console.log(products)

    return (
        <div className='page-content'>
            <div className="page-title">Promote Products</div>
            <div className="">

                <InfiniteScroll
                    dataLength={() => products.length}
                    next={false}
                    hasMore={false}
                >
                    <div className="products-container">
                        {isLoading && <Loader />}
                        {!isLoading && products.length === 0 && <p className="not-found-msg">No products found</p>}
                        {
                            products.length > 0 && products.map((product) => (
                                <div className="products-card-wrapper" key={product._id}>
                                    <AdProductCard product={product} />
                                </div>
                            ))
                        }
                    </div>
                </InfiniteScroll>

            </div>
        </div>
    )
}

export default ProductsAds